import { useContext, useEffect, useState } from "react";
import moment from "moment";

import { Page, Container } from "@/ui/Layout/Page";
import { Grid } from "@/ui/Grid";
import { Card } from "@/ui/Card";
import { cloneCampaign, getCampaigns, updateCampaign } from "@/api/campaigns";
import { ButtonTypes, Status } from "@/ui/types";
import { getSessionToken } from "@/api/auth";
import { Link, useNavigate } from "react-router-dom";
import Button from "@/ui/Button";
import { EmptyState } from "@/ui/Layout";
import { Loading } from "@/ui/Layout/Loading";
import { AppContext } from "@/AppContext";
import { setContextForView } from "../AITools/utils";

import { LAUNCH_OS_ICON } from "@/brand";
export const Content = ({ name = "" }) => {
  const [contentPackages, setContentPackages] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const contextObj = useContext(AppContext);
  const navigate = useNavigate();

  // get the contentPackages from the server
  const loadContentPackages = async () => {
    const token = getSessionToken();
    const response = await getCampaigns({ token, type: "content" });
    // const response = await getCampaigns({ token, type: "collection" });
    if (response) {
      // convert the response to the format that the Card components expect
      const seqs = response
        ?.filter(({ deleted }) => !deleted)
        .map((collection: any) => {
          return {
            id: collection.id,
            label: collection.name,
            caption: `Last Updated: ${moment(collection.updatedAt).fromNow()}`,
            img: (
              <img
                className="w-[42px] h-[42px] flex-none rounded-full overflow-hidden object-cover"
                src={LAUNCH_OS_ICON}
                alt=""
              />
            ), // funnel.screensnhot
            status: Status.INPROGRESS,
          };
        });

      setContentPackages(seqs);

      setContextForView({
        data: seqs.map(({ id, label, caption }) => ({ id, name: label, caption })),
        view: name,
      }, contextObj);
    }
    setIsLoading(false);
  };

  // Creates a new collection based on the collection funnel template
  const handleCreateContentPackage = async () => {
    const name = prompt("Enter a name for your collection");
    const campaignId = "cjz0ij1qz0ems0792n1kpu5ac"; // The ID of the collection campaign template (blank)
    if (name) {
      setIsLoading(true);
      const token = getSessionToken();
      const response = await cloneCampaign(campaignId, { token, name });
      const newCampaignId = response?.data?.cloneCampaign?.response?.id;

      // update the type of the campaign to be a content campaign
      const updateResponse = await updateCampaign(newCampaignId, {
        token,
        settings: {
          type: "content"
        },
      });
      
      console.log("newCampaignId", newCampaignId, updateResponse);

      if (newCampaignId) {
        // navigate to the new funnel
        navigate(`/content/${newCampaignId}`);
      }
    }
  };

  // load the contentPackages when the page loads
  useEffect(() => {
    loadContentPackages();
  }, []);

  return (
    <Page
      topBar={{
        page: [{ label: name }],
        items: (
          <Button
            label="+ Create a Content Package"
            type={ButtonTypes.OUTLINED}
            onClick={handleCreateContentPackage}
          />
        ),
      }}
    >
      <Container>
        {isLoading && <Loading type="gallery" />}
        {!isLoading && !Boolean(contentPackages.length) && (
          <EmptyState
            title="No Content Packages Yet"
            description="Get started by creating a new collection."
            showImage={false}
          >
            <Button
              label="Create a Content Package"
              type={ButtonTypes.DEFAULT}
              onClick={handleCreateContentPackage}
            />
          </EmptyState>
        )}
        {!isLoading && Boolean(contentPackages.length) && (
           <Grid className="pb-6">
            {/* Can we change to Gallery View - let's me toggle views */}
            {contentPackages.map(
              (
                {
                  id,
                  label,
                  caption,
                  img = "[logo]",
                  status,
                  // sharedWith,
                  taskDetails,
                },
                key
              ) => {
                return (
                  <Card
                    key={key}
                    label={label}
                    caption={caption}
                    image={img}
                    href={`/content/${id}`}
                    status={status}
                    taskDetails={taskDetails}
                  />
                );
              }
            )}
          </Grid>
        )}
      </Container>
    </Page>
  );
};
